var map = {
	"./bike-green.svg": 471,
	"./bike.svg": 47,
	"./coins.svg": 43,
	"./coins_red.svg": 320,
	"./employee.svg": 269,
	"./microchip-green.svg": 321,
	"./microchip.svg": 73,
	"./mobile phone.svg": 51,
	"./mobile-phone-green.svg": 322,
	"./resource_purple.svg": 233,
	"./resource_red.svg": 244,
	"./resource_white.svg": 270,
	"./resource_yellow.svg": 271,
	"./trophy.svg": 472,
	"./victory_points.svg": 74
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/resource-icons nonrecursive \.svg$
// module id = 63
// module chunks = 2 5